/**
 * @file Reusable panel container component.
 * @description Standard white rounded shadow surface used across pages and sections.
 * @author Sanjay Jangid (Jiggle frontend)
 * @email sanjay.jangid@dgtoohl.com
 * @date 2026-05-10
 * @version 0.0.0
 */
import React from 'react';
import { cn } from '../../utils/cn';

export interface PanelProps extends React.HTMLAttributes<HTMLDivElement> {
  padded?: boolean;
}

const Panel = React.forwardRef<HTMLDivElement, PanelProps>(
  ({ className, padded = false, children, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          'bg-white rounded-lg border-gray-200 border-1',
          padded ? 'p-4' : '',
          className,
        )}
        {...props}
      >
        {children}
      </div>
    );
  },
);

Panel.displayName = 'Panel';

export default Panel;
